import { createStyles, makeStyles, TableCell, TableRow } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import clsx from 'clsx';
import React from 'react';
import { ColumnInstance, HeaderGroup } from 'react-table';

export type DataGridLoadingRowsProps = {
  numberOfRows?: number;
  allColumns: ColumnInstance[];
  hiddenColumns?: string[];
  headerGroups: HeaderGroup[];
  tableOptions?: { [key: string]: any }; // eslint-disable-line @typescript-eslint/no-explicit-any
};

const useStyles = makeStyles(() =>
  createStyles({
    nonResizeable: {
      flex: '1 0 auto !important',
      display: 'flex',
    },
  }),
);

export const DataGridLoadingRows = ({
  numberOfRows = 12,
  allColumns,
  hiddenColumns = [],
  headerGroups,
  tableOptions,
}: DataGridLoadingRowsProps): JSX.Element => {
  const { style, className } = headerGroups[0].getHeaderGroupProps();
  const classes = useStyles();

  return (
    <>
      {Array.from(Array(numberOfRows)).map((_, index) => {
        return (
          <TableRow
            key={`loading-row-${index}`}
            data-testid={`loading-row-${index}`}
            style={style}
            className={clsx(className, tableOptions?.disableResizing == true && classes.nonResizeable)}
            component="div"
          >
            {allColumns.map((column, index) => {
              const isMenuCell = column.Header == 'Menu';
              if (isMenuCell) return undefined;

              const { style: cellStyle, className: cellClassName } = column.getHeaderProps();
              return (
                !hiddenColumns.includes(column.id || '') &&
                !column.disableFilters &&
                column.isVisible !== false && (
                  <TableCell
                    data-testid={`loading-cell-${column.id}`}
                    key={`loading-cell-${column.id}-${index}`}
                    style={cellStyle}
                    className={clsx(
                      cellClassName,
                      (column.disableResizing || tableOptions?.disableResizing == true) && classes.nonResizeable,
                    )}
                    component="div"
                  >
                    {column.id !== 'selection' && <Skeleton data-testid="skeleton" width={'100%'} />}
                  </TableCell>
                )
              );
            })}
          </TableRow>
        );
      })}
    </>
  );
};
